<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('fighters.categories.create')
  }),
  computed: {
    ...mapState('fightersCategories', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('fighters.title'), to: { name: 'fighters.index' } },
      { text: vm.$t('fighters.categories.title'), to: { name: 'fighters.categories.index' } },
      { text: vm.$t('fighters.categories.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('fightersCategories/clearItem')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('fightersCategories', ['createItem', 'updateItem'])
  }
}
</script>
